import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getTransports = async (values) => {
  return await request.get(
    `/HousingStock/transport`,
    values,
    'При загрузке транспортных средств произошла ошибка',
    []
  );
};

const useTransports = ({ clientId, houseId }, options = {}) => {
  return useQuery(
    getQueryKeys.transports({ clientId, houseId }),
    () => getTransports({ clientId, houseId }),
    options
  );
};
export default useTransports;
